<template>
  <div id="wallet_container"></div>
</template>

<script>
// const mp = new MercadoPago('APP_USR-84f23e5d-dc28-419b-bc44-e7421dd68b76');
// const bricksBuilder = mp.bricks();

export default {
  components: {},
  computed: {},
  data() {
    return {}
  },
  methods: {
    loadMercadoPago() {
      // mp.bricks().create("wallet", "wallet_container", {
      //   initialization: {
      //     preferenceId: "<PREFERENCE_ID>"
      //   },
      //   customization: {
      //     texts: {
      //       valueProp: "smart_option"
      //     }
      //   }
      // })
    }
  },
  created() {}
}
</script>

<style lang="less" scoped>
</style>
